/* eslint-disable */
import React, { useEffect } from "react";
import LoginNav from "../components/header/LoginNav";
import AOS from "aos";

const EmergencyContact = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <div className="relative bg-white">
      <div className="mx-auto max-w-7xl mb-8 sm:mb-12 md:mb-16">
        <LoginNav />

        <div className="flex items-start flex-wrap mb-20 md:gap-0 py-8 sm:py-12 md:py-16">
          <div className="w-full sm:w-1/2 px-4 sm:px-8 md:px-10">
            <div className="lg:mx-10 xl:mx-16 p-4 md:p-10 border border-oya-ghana-border shadow-form rounded-xl">
              <div className="text-left">
                <h3 className="text-oya-ghana-header-h5 pb-5">
                  Add Emergency Contact
                </h3>

                <p className="text-sm pb-5">
                  In case of any emergency please provide the phone numbers of 2
                  people we can contact
                </p>
              </div>

              <form className="w-full">
                <div className="w-full mb-6">
                  <label className="text-gray-500 text-sm">
                    Emergency Contact 1
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10"
                  />{" "}
                </div>
                <div className="w-full mb-6">
                  <label className="text-gray-500 text-sm">
                    Emergency Contact 2
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10"
                  />{" "}
                </div>

                <button
                  type="submit"
                  className="w-full my-5 bg-oya-ghana-green rounded-md py-3 text-white"
                >
                  Continue
                </button>
              </form>
            </div>
          </div>

          <div className="hidden sm:block w-full sm:w-1/2">
            <div className="md:px-5 ">
              <img
                src="/assets/images/login/emergency.png"
                data-aos="zoom-in"
                data-aos-duration="1500"
                alt="login-hero"
              />
              <div className="flex flex-col items-start">
                <h1 className="lg:text-oya-ghana-header-h3 leading-tight text-2xl my-5 font-bold lg:w-[70%] md:[100%]  ">
                  Get Started in one, two, three...
                </h1>
                <p className="my-5 lg:w-[70%]">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolorem, eum. Soluta nulla ratione laboriosam officia nihil?
                  Cupiditate libero repellendus nemo!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContact;
